import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getEasypostShipmentForFulfillmentGroup = {
  name: "getEasypostShipmentForFulfillmentGroup" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    shipmentId: z.string(),
  }),
  output: z.object({ shipment: z.object({}).passthrough() }),
};
